'use client'
import { useRowLabel } from '@payloadcms/ui'

import { etichettaStato } from '@/negozio/ordini/stati'
import type { Ordine } from '@/payload-types'

const dataOra = new Intl.DateTimeFormat('it-IT', { dateStyle: 'short', timeStyle: 'short' })

export const StoricoRowLabel: React.FC = () => {
  const { data, rowNumber } = useRowLabel<NonNullable<Ordine['storicoStati']>[number]>()
  const parti = [
    data?.stato && etichettaStato(data.stato),
    data?.data && dataOra.format(new Date(data.data)),
  ].filter(Boolean)
  return <div>{parti.length ? parti.join(' · ') : `Cambio ${(rowNumber ?? 0) + 1}`}</div>
}
